import {
  onBeforeUnmount, onMounted, ref, watch,
} from 'vue';
import { useRoute } from 'vue-router';

// A disclosure: a button with aria-expanded and a panel under it. Closes on a click outside,
// on Escape (focus back on the button) and on navigation.
export default function usePopover() {
  const open = ref(false);
  const root = ref(null);
  const route = useRoute();

  const close = () => { open.value = false; };
  const onClick = (e) => {
    if (open.value && root.value && !root.value.contains(e.target)) close();
  };
  const onKey = (e) => {
    if (e.key !== 'Escape' || !open.value) return;
    close();
    root.value?.querySelector('[aria-expanded]')?.focus();
  };

  onMounted(() => {
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', onClick);
    document.removeEventListener('keydown', onKey);
  });
  watch(() => route.fullPath, close);

  return {
    open, root, close, toggle: () => { open.value = !open.value; },
  };
}
